import { CanDeactivateFn } from '@angular/router';

export const leaveTestWarningGuard: CanDeactivateFn<unknown> = (component, currentRoute, currentState, nextState) => {
  if (!nextState.url.startsWith('/evaluation/')) {
    return window.confirm("Achtung! Wenn du die Seite verlässt, wird die Prüfungssimulation verworfen! Möchtest du die Seite wirklich verlassen?");
  }
  return true;
};
